import { Redirect, Route, Switch } from "react-router-dom";
import dashboardRoutes, { commonerRoutes, installerRoutes, loginRoutes, wiseneRoutes } from "../routes/dashboard";

import Footer from "../components/Footer/Footer";
// core components
import Header from "../components/Header/Header";
import PropTypes from "prop-types";
import React from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import appStyle from "../assets/jss/layouts/dashboardStyle";
import { checkScreenSize } from "../stores/actions/dashboardActions";
import { connect } from "react-redux";
import cx from "classnames";
import image from "../assets/img/login_bg.jpg";
import logoMini from "../assets/img/WISENE_logo_small.png";
import logoNormal from "../assets/img/WISENE_logo_big.png";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

const switchRoutes = (allRoutes) => {
  return (
    <Switch>
      {allRoutes.map((prop, index) => {
        if (prop.redirect) {
          return <Redirect from={prop.path} to={prop.pathTo} key={`route-${prop.name}`} />;
        }
        if (prop.collapse) {
          return prop.views.map((prop, key) => {
            return <Route exact path={prop.path} component={prop.component} key={`route-${prop.name}`} />;
          });
        }
        return <Route exact path={prop.path} component={prop.component} key={`route-${prop.name}`} />;
      })}
    </Switch>
  );
};

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      miniActive: true,
      routes: this.props.routes,
    };
    this.resize = this.resize.bind(this);
    this.getRoutes = this.getRoutes.bind(this);
  }

  clientX = null;

  componentWillMount() {
    this.setState({ routes: this.getRoutes() });
  }

  getRoutes() {
    const { accountCategory } = this.props;
    let routes = dashboardRoutes;
    if (accountCategory === "commoner") {
      routes = routes.concat(commonerRoutes);
    }
    if (accountCategory === "installer" || accountCategory === "wisene") {
      routes = routes.concat(installerRoutes);
    }
    if (accountCategory === "wisene") {
      routes = routes.concat(wiseneRoutes);
    }
    const systemsCount = this.props.systems ? this.props.systems.length : 0;
    routes.forEach(route => {
        if (route.name === "Dashboard") {
            route.hidden = systemsCount !== 1;
        } else if (route.name === "Systems") {
            route.hidden = systemsCount === 1;
        }
    });
    return routes.concat(loginRoutes);
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize);
    window.addEventListener("resize", () => this.props.checkScreenSize(this.props.mobileView));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
    window.removeEventListener("resize", () => this.props.checkScreenSize(this.props.mobileView));
  }

  componentDidUpdate(prevProps, prevState) {
    // this.setState({ routes: this.getRoutes() });
    this.props.checkScreenSize(this.props.mobileView);
    if (prevProps.history.location.pathname !== prevProps.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
    if ((this.props.systems?.length === 1 || prevProps.systems?.length === 1) && prevProps.systems?.length !== this.props.systems?.length) {
      this.setState({ routes: this.getRoutes() });
    }
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }

  resize() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  render() {
    const { systems, accountCategory, classes, ...rest } = this.props;
    const allRoutes = this.state.routes;
    const systemId = systems && systems.length ? systems[0].ID : 0;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive
      });
    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={allRoutes}
          logoNormal={logoNormal}
          logoMini={logoMini}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          bgColor="black"
          miniActive={this.state.miniActive}
          systemId={systemId}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <Header
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            routes={allRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes(allRoutes)}</div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
    systems: state.dashboard.systems,
    accountCategory: state.login.accountCategory,
    mobileView: state.dashboard.mobileView,
  };
};

const actions = { checkScreenSize };

export default connect(mapStateToProps, actions)(withStyles(appStyle)(Dashboard));
